import { ROLES } from '@tempus/trials-types';

/** Roles allowed to open the unified `/patient/...` workspace (any tab the user may use). */
export const PATIENT_WORKSPACE_AUTHORIZED_ROLES: string[] = [
  ROLES.T_PATIENT_TRACKER_READ,
  ROLES.T_PATIENT_TRACKER_READ_INTERNAL,
  ROLES.NEXT_PRESCREENING_USER,
  ROLES.NEXT_PATIENT_TRACKING_USER,
  ROLES.NEXT_PATIENT_TRACKING_USER_INTERNAL,
];

export function effectiveRolesCanAccessPatientWorkspace(effectiveRoles: string[]): boolean {
  return effectiveRoles.some((role) => PATIENT_WORKSPACE_AUTHORIZED_ROLES.includes(role));
}
